import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled Radio Button Group
 *
 * @param props - ariaLabel, children, defaultValue, name, onChange, value, text, spacing
 * @example
 * <RadioGroup
 * 	id=''
 * 	ariaLabel={"Radio Group"}
 * 	defaultValue={"Radio 1"}
 * 	name={"Radio Group"}
 * 	onChange={() => {}}
 * 	value={"Radio 1"}
 * 	text={"Radio Group"}
 * 	spacing={1}
 * >
 * 	{children}
 * </RadioGroup>
 * @returns React.ReactElement
 */
var RadioGroup = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
RadioGroup.defaultProps = {
    ariaLabel: "Radio Group",
};
var SampleProps = {};
export default RadioGroup;
export { SampleProps as RadioGroupSample, };
